










import Vue from "vue";
export default Vue.extend({
  props: {
    filterType: {
      type: String,
    },
  },
});
